export const cm_zhCN = {
  'cm.member.n01.lbl01': `会员号`,
  'cm.member.n01.lbl02': `会员姓名`,
  'cm.member.n01.lbl03': `手机号`,
  'cm.member.n01.lbl04': `会员等级`,
  'cm.member.n01.lbl05': `入会渠道`,
  'cm.member.n01.lbl06': `注册开始日期`,
  'cm.member.n01.lbl07': `注册结束日期`,
  'cm.member.n01.lbl08': `注册门店`,
  'cm.member.n01.lbl09': `服务门店`,
  'cm.member.n01.btn10': `重置`,
  'cm.member.n01.btn11': `查询`,
  'cm.member.c01.lbl01': `会员号`,
  'cm.member.c01.lbl02': `会员姓名`,
  'cm.member.c01.lbl03': `手机号`,
  'cm.member.c01.lbl04': `性别`,
  'cm.member.c01.lbl05': `会员等级`,
  'cm.member.c01.lbl06': `可用积分`,
  'cm.member.c01.lbl07': `入会渠道`,
  'cm.member.c01.lbl08': `注册日期`,
  'cm.member.c01.lbl09': `注册门店`,
  'cm.member.c01.lbl10': `服务门店`,
  'cm.member.c01.lbl11': `操作`,
  'cm.member.c01.1bl12': `筛选条数`,
  'cm.member.c01.1bl13': `总条数`,
  'cm.member.detail.n01.lbl01': `会员姓名`,
  'cm.member.detail.n01.lbl02': `性别`,
  'cm.member.detail.n01.lbl03': `会员号`,
  'cm.member.detail.n01.lbl04': `手机号`,
  'cm.member.detail.n01.lbl05': `会员等级`,
  'cm.member.detail.n02.lbl01': `基本信息`,
  'cm.member.detail.n02.lbl02': `身份绑定记录`,
  'cm.member.detail.n02.lbl03': `消费记录`,
  'cm.member.detail.n02.lbl04': `积分历史`,
  'cm.member.detail.n02.lbl05': `等级变化历史`,
  'cm.member.detail.n02.lbl06': `优惠券记录`,
  'cm.member.detail.n03.lbl01': `生日`,
  'cm.member.detail.n03.lbl02': `注册时间`,
  'cm.member.detail.n03.lbl03': `入会渠道`,
  'cm.member.detail.n03.lbl04': `总剩余积分`,
  'cm.member.detail.n03.lbl05': `可用积分`,
  'cm.member.detail.n03.lbl06': `合计冻结积分`,
  'cm.member.detail.n03.lbl07': `升级所需金额`,
  'cm.member.detail.n03.lbl08': `分公司名称`,
  'cm.member.detail.n03.lbl09': `注册门店`,
  'cm.member.detail.n03.lbl10': `服务门店`,
  'cm.member.detail.n03.lbl11': `绑定门店`,
  'cm.member.detail.n03.lbl12': `电子邮箱`,
  'cm.member.detail.n03.lbl13': `行业`,
  'cm.member.detail.n03.lbl14': `职业`,
  'cm.member.detail.n03.lbl15': `省市区`,
  'cm.member.detail.n03.lbl16': `地址`,
  'cm.member.detail.n03.lbl17': `鞋码`,
  'cm.member.detail.n03.lbl18': `婚姻状况`,
  'cm.member.detail.n03.lbl19': `上次消费的门店`,
  'cm.member.detail.n03.lbl20': `上次购买的商品`,
  'cm.member.detail.n03.lbl21': `是否跨性别购买`,
  'cm.member.detail.n03.lbl22': `是否特码鞋`,
  'cm.member.detail.n03.lbl23': `购买过尺码`,
  'cm.member.detail.n03.lbl24': `购买间隔`,
  'cm.member.detail.n03.lbl25': '喜欢的产品',
  'cm.member.detail.n03.lbl26': '购鞋对象',
  'cm.member.detail.n03.lbl27': '购鞋动机',
  'cm.member.detail.c01.lbl01': `绑定渠道`,
  'cm.member.detail.c01.lbl02': `渠道名称`,
  'cm.member.detail.c01.lbl03': `身份类型`,
  'cm.member.detail.c01.lbl04': `操作类型`,
  'cm.member.detail.c01.lbl05': `身份变动时间`,
  'cm.member.detail.c01.lbl06': `账号`,
  'cm.member.detail.c01.lbl07': `操作人`,
  'cm.member.detail.c02.lbl01': `交易类型`,
  'cm.member.detail.c02.lbl02': `交易时间`,
  'cm.member.detail.c02.lbl03': `交易单号`,
  'cm.member.detail.c02.lbl04': `原单号`,
  'cm.member.detail.c02.lbl05': `交易渠道`,
  'cm.member.detail.c02.lbl06': `交易门店`,
  'cm.member.detail.c02.lbl07': `交易金额`,
  'cm.member.detail.c02.lbl08': `实付金额`,
  'cm.member.detail.c02.lbl09': `优惠金额`,
  'cm.member.detail.c03.lbl01': `积分变动时间`,
  'cm.member.detail.c03.lbl02': `积分生效时间`,
  'cm.member.detail.c03.lbl03': `积分过期时间`,
  'cm.member.detail.c03.lbl04': `变动原因`,
  'cm.member.detail.c03.lbl05': `交易单号`,
  'cm.member.detail.c03.lbl06': `渠道名称`,
  'cm.member.detail.c03.lbl07': `积分`,
  'cm.member.detail.c03.lbl08': `剩余积分`,
  'cm.member.detail.c03.lbl09': `操作人`,
  'cm.member.detail.d03.lbl01': '交易详情',
  'cm.member.detail.c04.lbl01': `等级变动时间`,
  'cm.member.detail.c04.lbl02': `变动前等级`,
  'cm.member.detail.c04.lbl03': `变动后等级`,
  'cm.member.detail.c04.lbl04': `变动原因`,
  'cm.member.detail.c04.lbl05': `操作人`,
  'cm.member.detail.c05.lbl01': `优惠券名称`,
  'cm.member.detail.c05.lbl02': `优惠券类型`,
  'cm.member.detail.c05.lbl03': `折扣/金额`,
  'cm.member.detail.c05.lbl04': `优惠券Code`,
  'cm.member.detail.c05.lbl05': `当前状态`,
  'cm.member.detail.c05.lbl06': `发放时间`,
  'cm.member.detail.c05.lbl07': `领取时间`,
  'cm.member.detail.c05.lbl08': `过期时间`,
  'cm.member.detail.c05.lbl09': `核销时间`,
  'cm.member.detail.c05.lbl10': `操作人`,
};
export const cm_enUS = {
  'cm.member.n01.lbl01': `MEMBER ID`,
  'cm.member.n01.lbl02': `MEMBER NAME`,
  'cm.member.n01.lbl03': `MP NUMBER`,
  'cm.member.n01.lbl04': `RANK`,
  'cm.member.n01.lbl05': `ROUTE OF REGISTRATION`,
  'cm.member.n01.lbl06': `BEGINNING OF DOR`,
  'cm.member.n01.lbl07': `ENDING OF DOR`,
  'cm.member.n01.lbl08': `STORE OF REGISTRATION`,
  'cm.member.n01.lbl09': `STORE OF ACTIVE`,
  'cm.member.n01.btn10': `RESET`,
  'cm.member.n01.btn11': `SEARCH`,
  'cm.member.c01.lbl01': `MEMBER ID`,
  'cm.member.c01.lbl02': `MEMBER NAME`,
  'cm.member.c01.lbl03': `MP NUMBER`,
  'cm.member.c01.lbl04': `GENDER`,
  'cm.member.c01.lbl05': `RANK`,
  'cm.member.c01.lbl06': `POINTS AVAILABLE`,
  'cm.member.c01.lbl07': `SOURCE OF REGISTRATION`,
  'cm.member.c01.lbl08': `DATE OF REGISTRATION`,
  'cm.member.c01.lbl09': `STORE OF REGISTRATION`,
  'cm.member.c01.lbl10': `STORE OF ACTIVE`,
  'cm.member.c01.lbl11': `ACTIONS`,
  'cm.member.c01.1bl12': `Filtered Data`,
  'cm.member.c01.1bl13': `All Data`,
  'cm.member.detail.n01.lbl01': `MEMBER NAME`,
  'cm.member.detail.n01.lbl02': `GENDER`,
  'cm.member.detail.n01.lbl03': `MEMBER ID`,
  'cm.member.detail.n01.lbl04': `MP NUMBER`,
  'cm.member.detail.n01.lbl05': `RANK`,
  'cm.member.detail.n02.lbl01': `STATUS`,
  'cm.member.detail.n02.lbl02': `BONDING RECORDS`,
  'cm.member.detail.n02.lbl03': `CONSUMPTION `,
  'cm.member.detail.n02.lbl04': `POINTS HISTORY`,
  'cm.member.detail.n02.lbl05': `RANK HISTORY`,
  'cm.member.detail.n02.lbl06': `VOUCHERS HISTORY`,
  'cm.member.detail.n03.lbl01': `BIRTHDAY`,
  'cm.member.detail.n03.lbl02': `DATE OF REGISTRATION`,
  'cm.member.detail.n03.lbl03': `SOURCE OF REGISTRATION`,
  'cm.member.detail.n03.lbl04': `POINTS REMAINING`,
  'cm.member.detail.n03.lbl05': `POINTS AVAILABLE`,
  'cm.member.detail.n03.lbl06': `POINTS FROZEN`,
  'cm.member.detail.n03.lbl07': `VALUES TO NEXT RANK`,
  'cm.member.detail.n03.lbl08': `NAME OF SUBSIDIARY`,
  'cm.member.detail.n03.lbl09': `STORE OF REGISTRATION`,
  'cm.member.detail.n03.lbl10': `STORE OF ACTIVE`,
  'cm.member.detail.n03.lbl11': `STORE OF BINDED`,
  'cm.member.detail.n03.lbl12': `E-MAIL ADDRESS`,
  'cm.member.detail.n03.lbl13': `PROFESSION`,
  'cm.member.detail.n03.lbl14': `JOB OCCUPATION`,
  'cm.member.detail.n03.lbl15': `REGION`,
  'cm.member.detail.n03.lbl16': `ADDRESS`,
  'cm.member.detail.n03.lbl17': `SHOE SIZE`,
  'cm.member.detail.n03.lbl18': `MARITAL STATUS`,
  'cm.member.detail.n03.lbl19': `Last Store Consumed`,
  'cm.member.detail.n03.lbl20': `Last Item Consumed`,
  'cm.member.detail.n03.lbl21': `Is transgender`,
  'cm.member.detail.n03.lbl22': `Is Special Size`,
  'cm.member.detail.n03.lbl23': `Size Consumed`,
  'cm.member.detail.n03.lbl24': `Payment Interval`,
  'cm.member.detail.n03.lbl25': 'Like',
  'cm.member.detail.n03.lbl26': 'Purchased for',
  'cm.member.detail.n03.lbl27': 'Purchased reason',
  'cm.member.detail.c01.lbl01': `SOURCE OF BINDING`,
  'cm.member.detail.c01.lbl02': `SOURCE`,
  'cm.member.detail.c01.lbl03': `ID TYPE`,
  'cm.member.detail.c01.lbl04': `ACTION TYPE`,
  'cm.member.detail.c01.lbl05': `ACTION TIME`,
  'cm.member.detail.c01.lbl06': `ACCOUNT`,
  'cm.member.detail.c01.lbl07': `OPERATOR`,
  'cm.member.detail.c02.lbl01': `TRADE TYPE`,
  'cm.member.detail.c02.lbl02': `ORDER TIME`,
  'cm.member.detail.c02.lbl03': `ORDER ID`,
  'cm.member.detail.c02.lbl04': `ORIGINAL ORDER ID`,
  'cm.member.detail.c02.lbl05': `SOURCE OF TRADE`,
  'cm.member.detail.c02.lbl06': `STORE OF TRADE`,
  'cm.member.detail.c02.lbl07': `ORDER VALUE`,
  'cm.member.detail.c02.lbl08': `ACTUALLY PAID`,
  'cm.member.detail.c02.lbl09': `DISCOUNT VALUE`,
  'cm.member.detail.c03.lbl01': `POINTS CHANGED TIME`,
  'cm.member.detail.c03.lbl02': `POINTS VALID TIME`,
  'cm.member.detail.c03.lbl03': `POINTS EXPIRED UNTIL`,
  'cm.member.detail.c03.lbl04': `REASON`,
  'cm.member.detail.c03.lbl05': `ORDER ID`,
  'cm.member.detail.c03.lbl06': `SOURCE`,
  'cm.member.detail.c03.lbl07': `POINTS`,
  'cm.member.detail.c03.lbl08': `POINTS REMAINING`,
  'cm.member.detail.c03.lbl09': `OPERATOR`,
  'cm.member.detail.d03.lbl01': 'ORDER DETAIL',
  'cm.member.detail.c04.lbl01': `RANK CHANGED TIME`,
  'cm.member.detail.c04.lbl02': `RANK BEFORE OPERATION`,
  'cm.member.detail.c04.lbl03': `RANK AFTER OPERATION`,
  'cm.member.detail.c04.lbl04': `REASON`,
  'cm.member.detail.c04.lbl05': `OPERATOR`,
  'cm.member.detail.c05.lbl01': `VOUCHER NAME`,
  'cm.member.detail.c05.lbl02': `VOUCHER TYPE`,
  'cm.member.detail.c05.lbl03': `VOUCHER VALUES`,
  'cm.member.detail.c05.lbl04': `VOUCHER CODE`,
  'cm.member.detail.c05.lbl05': `STATUS`,
  'cm.member.detail.c05.lbl06': `TIME OF ISSUE`,
  'cm.member.detail.c05.lbl07': `TIME OF RECEIVE`,
  'cm.member.detail.c05.lbl08': `TIME OF INVALID`,
  'cm.member.detail.c05.lbl09': `TIME OF WRITE OFF`,
  'cm.member.detail.c05.lbl10': `OPERATOR`,
};
